import React, { useState, useEffect } from "react";
import "./MakeUpMainScreen.css";
import lipstickRadioImage from "../../Images/lipstickRadioImage.png";
import { useNavigate } from "react-router-dom";

const MakeUpMainScreen = () => {
  const navigate = useNavigate();
  const [radioValues, setradioValues] = useState(null);
  const [AccessToken, setAccessToken] = useState()
  useEffect(() => {
    const storedAccessToken = localStorage.getItem("AccessToken");
    setAccessToken(storedAccessToken)
  }, []);
  const menus = [
    {
      label: "hair",
      description: "change your hair color what-ever you want.",
      image: lipstickRadioImage,
    },
    {
      label: "blush",
      description: "change your hair color what-ever you want.",
      image: lipstickRadioImage,
    },
    {
      label: "lipstick",
      description: "change your hair color what-ever you want.",
      image: lipstickRadioImage,
    },
    {
      label: "eyeshadow",
      description: "change your hair color what-ever you want.",
      image: lipstickRadioImage,
    },
    {
      label: "eyeliner",
      description: "change your hair color what-ever you want.",
      image: lipstickRadioImage,
    },
  ];

  const handleRadioValues = (label) => {
    setradioValues(label);

    navigate(`/${AccessToken}/${label}`);
  };

  return (
    <>
      <div className="MakeUpMainScreenContainer">
        <h3 className="selectMakeHeading">
          select makeup what kind of you want to apply!
        </h3>
        <div className="makeUpRadioButtonsContainer">
          {menus?.map((item, index) => {
            return (
              <div
                className={`RadioBoxes ${radioValues === item.label && "active"
                  }`}
                key={index}
                onClick={() => handleRadioValues(item.label)}
              >
                <img src={lipstickRadioImage} alt="lipstickRadioImage" />
                <div className="content">
                  <div>
                    <h4 onClick={() => handleRadioValues(item.label)}>
                      {item.label}
                    </h4>
                    <input
                      type="radio"
                      id={item.label}
                      name="makeup"
                      className="makeupRadio"
                      checked={radioValues === item.label}
                      onChange={() => handleRadioValues(item.label)}
                    />
                  </div>
                  <p>{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default MakeUpMainScreen;
